/**
 * Declare an optimistic write to a collection other than the mutation's own.
 *
 * ```ts
 * patch('project.entityOrder', () => {
 *   const before = projectCollection.get(projectId);
 *   projectCollection.push([reorder(before)], { source: 'local' });
 *   return () => projectCollection.push([before], { source: 'local' });
 * });
 * ```
 *
 * Note the `'local'` source on both writes. A companion patch is this tab's
 * guess, not server truth — broadcasting it hands peers a value that a
 * rollback here can no longer retract there. Peers converge via `sync.signals`
 * instead, and `defineMutation` reports a `'mutation'`-sourced push made
 * during the optimistic window as a contract violation.
 */ export const patch = (name, apply)=>({
        name,
        apply
    });
